import { Role, Service, Council, StudyLevelConfiguration, Fine } from "@/types";
import { ApprovalEntry } from "@/types/educationbackground.type";
import { atom } from "recoil";

export const systemRoles = atom<Role[]>({
  key: "systemRoles",
  default: [] as Role[],
});

export const showCreateRoleState = atom({
  key: "showCreateRoleState",
  default: false,
});
export const useSideBarFilter = atom<{
  useFilter: boolean;
  filterParam: string;
} | null>({
  key: "useSideBarFilter",
  default: null,
});

export const showApproveRequestState = atom<{
  show: boolean;
  requestId: string;
  action: "approve" | "reject";
} | null>({
  key: "showApproveRequestState",
  default: null,
});

export const showAddUserState = atom({
  key: "showAddUserState",
  default: false,
});

export const showDeleteRoleState = atom<{
  show: boolean;
  roleId: string;
} | null>({
  key: "showDeleteRoleState",
  default: null,
});

export const showDeleteExitAwardState = atom<{
  show: boolean;
  exitAwardId: string;
} | null>({
  key: "showDeleteExitAwardState",
  default: null,
});

export const showDeleteAcademicDegreeProgramState = atom<{
  show: boolean;
  AcademicDegreeProgramId: string;
} | null>({
  key: "showDeleteAcademicDegreeProgramState",
  default: null,
});

export const showDeleteProfessionCategoryState = atom<{
  show: boolean;
  ProfessionCategoryId: string;
} | null>({
  key: "showDeleteProfessionCategoryState",
  default: null,
});

export const showDeleteProfessionCredentialState = atom<{
  show: boolean;
  ProfessionCredentialId: string;
} | null>({
  key: "showDeleteProfessionCredentialState",
  default: null,
});

export const showDeleteInstitutionState = atom<{
  show: boolean;
  InstitutionId: string;
} | null>({
  key: "showDeleteInstitutionState",
  default: null,
});

export const showDeleteBankState = atom<{
  show: boolean;
  BankId: string;
} | null>({
  key: "showDeleteBankState",
  default: null,
});

export const showDeleteServiceState = atom<{
  show: boolean;
  service: Service
} | null>({
  key: "showDeleteServiceState",
  default: null,
});


export const showEditRoleState = atom<{
  show: boolean;
  roleId: string;
} | null>({
  key: "showEditRoleState",
  default: null,
});

export const showManageUserState = atom<{
  show: boolean;
  userId: string;
} | null>({
  key: "showManageUserState",
  default: null,
});

export const showAddOrEditCouncilState = atom<{
  show: boolean;
  action: "add" | "edit";
  council?: Council
} | null>({
  key: "showAddOrEditCouncilState",
  default: null,
});

export const showDeleteCouncilState = atom<{
  show: boolean;
  council: Council;
} | null>({
  key: "showDeleteCouncilState",
  default: null,
});

export const showAddOrEditApprovalStructureState = atom<{
  show: boolean;
  action: 'add' | 'edit';
  approvalStructure?: ApprovalEntry;
} | null>({
  key: 'showAddOrEditApprovalStructureState',
  default: null,
});

export const showDeleteApprovalStructureState = atom<{
  show: boolean;
  approvalStructure?: ApprovalEntry;
} | null>({
  key: 'showDeleteApprovalStructureState',
  default: null,
});

export const showDeleteStudyLevelState = atom<{
  show: boolean;
  studyLevel: StudyLevelConfiguration;
} | null>({
  key: "showDeleteStudyLevelState",
  default: null,
});

export const showAddOrEditStudyLevelState = atom<{
  show: boolean;
  action: "add" | "edit";
  studyLevel?: StudyLevelConfiguration;
} | null>({
  key: "showAddOrEditStudyLevelState",
  default: null,
});

export const showDeleteFineState = atom<{
  show: boolean;
  fine: Fine;
} | null>({
  key: "showDeleteFineState",
  default: null,
});

export const showAddOrEditFineState = atom<{
  show: boolean;
  action: "add" | "edit";
  fine?: Fine;
} | null>({
  key: "showAddOrEditFineState",
  default: null,
});

export const showAddOrUpdateServiceState = atom<{
  show: boolean;
  action: "add" | "edit";
  service?: Service;
} | null>({
  key: "showAddOrUpdateServiceState",
  default: null
})